<template>
  <label class="full-width">
    <div class="d-flex">
      <span class="label textarea-label text-title">{{ label || name }}</span>
      <span v-if="hintLabel" class="text-gray font-italic ml-1">{{
        hintLabel
      }}</span>
    </div>
    <textarea
      v-model="text"
      class="form-control"
      :name="name"
      :rows="rows"
      :class="{ 'is-invalid': errorText }"
      :disabled="disabled"
      :data-cy="testId"
      @blur="$emit('blur')"
    ></textarea>
    <span v-if="errorText" class="text-danger error-text">{{ errorText }}</span>
  </label>
</template>

<script>
import { kebabCase } from "@/lib/helpers.js";
import { findByName } from "@/lib/vuelidate_helpers";

export default {
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    validationErrors: {
      type: Object,
      default: null
    },
    errorMessage: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    hintLabel: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    rows: {
      type: Number,
      default: 3
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["blur", "update:modelValue"],
  computed: {
    errorText() {
      return this.errorMessage || findByName(this.validationErrors, this.name);
    },
    text: {
      get() {
        return this.modelValue;
      },
      set(val) {
        return this.$emit("update:modelValue", val);
      }
    },
    testId() {
      return kebabCase(this.label || this.name) || "text-area";
    }
  }
};
</script>

<style lang="scss" scoped>
.textarea-label {
  margin-left: 2px;
  margin-bottom: 3px;
  display: inline-block;
}
</style>
